import React from "react";

import { MenuSettings } from "features/MenuSettings";
import { PageTitle } from "shared/ui";

const MenuSettingsPage = () => {
    return (
        <>
            <PageTitle>Настройки меню</PageTitle>
            <MenuSettings />
        </>
    );
};

export default MenuSettingsPage;
